import Vue from 'vue'
import moment from 'moment'
import i18n from '../i18n'
import Store from '../store/index'

function formatNumber (value) {
  return Number(value).toLocaleString()
}
// const formatForDate = Store.getters.commonObj.dateFormat

function dateFormat (value, format = 'DD/MM/YYYY') {
    require('moment/min/locales.min')
    moment.locale(i18n.locale)
    if (value == null) {
        return ''
    }
    return moment(value).format(format)
}
function newDateFormat (value, format = 'DD/MM/YYYY') {
    require('moment/min/locales.min')
    moment.locale(i18n.locale)
    if (value == null) {
        return ''
    }
    return moment(value).format(format)
}

function numberToBengaliWords (number) {
    const ones = ['', 'এক', 'দুই', 'তিন', 'চার', 'পাঁচ', 'ছয়', 'সাত', 'আট', 'নয়',
                  'দশ', 'এগারো', 'বারো', 'তেরো', 'চৌদ্দ', 'পনেরো', 'ষোলো', 'সতেরো',
                  'আঠারো', 'ঊনিশ', 'বিশ', 'একুশ', 'বাইশ', 'তেইশ', 'চব্বিশ',
                  'পঁচিশ', 'ছাব্বিশ', 'সাতাশ', 'আটাশ', 'ঊনত্রিশ', 'ত্রিশ', 'একত্রিশ',
                  'বত্রিশ', 'তেত্রিশ', 'চৌত্রিশ', 'পঁয়ত্রিশ', 'ছত্রিশ', 'সাঁইত্রিশ',
                  'আটত্রিশ', 'ঊনচল্লিশ', 'চল্লিশ', 'একচল্লিশ', 'বিয়াল্লিশ', 'তেতাল্লিশ',
                  'চুয়াল্লিশ', 'পঁয়তাল্লিশ', 'ছেচল্লিশ', 'সাতচল্লিশ', 'আটচল্লিশ',
                  'ঊনপঞ্চাশ', 'পঞ্চাশ', 'একান্ন', 'বায়ান্ন', 'তিপ্পান্ন', 'চুয়ান্ন',
                  'পঞ্চান্ন', 'ছাপ্পান্ন', 'সাতান্ন', 'আটান্ন', 'ঊনষাট', 'ষাট',
                  'একষট্টি', 'বাষট্টি', 'তেষট্টি', 'চৌষট্টি', 'পঁয়ষট্টি', 'ছেষট্টি',
                  'সাতষট্টি', 'আটষট্টি', 'ঊনসত্তর', 'সত্তর', 'একাত্তর', 'বাহাত্তর',
                  'তিয়াত্তর', 'চুয়াত্তর', 'পঁচাত্তর', 'ছিয়াত্তর', 'সাতাত্তর',
                  'আটাত্তর', 'ঊনআশি', 'আশি', 'একাশি', 'বিরাশি', 'তিরাশি', 'চুরাশি',
                  'পঁচাশি', 'ছিয়াশি', 'সাতাশি', 'আটাশি', 'ঊননব্বই', 'নব্বই',
                  'একানব্বই', 'বিরানব্বই', 'তিরানব্বই', 'চুরানব্বই', 'পঁচানব্বই',
                  'ছিয়ানব্বই', 'সাতানব্বই', 'আটানব্বই', 'নিরানব্বই', 'একশ']
    const hundred = 'শত'
    const thousand = 'হাজার'
    const lakh = 'লক্ষ'
    const crore = 'কোটি'
    if (number < 100) {
        return ones[number]
    }
    let words = ''
    if (number >= 10000000) { // Crore
        words += numberToBengaliWords(Math.floor(number / 10000000)) + ' ' + crore + ' '
        number = number % 10000000
    }
    if (number >= 100000) { // Lakh
        words += numberToBengaliWords(Math.floor(number / 100000)) + ' ' + lakh + ' '
        number = number % 100000
    }
    if (number >= 1000) { // Thousand
        words += numberToBengaliWords(Math.floor(number / 1000)) + ' ' + thousand + ' '
        number = number % 1000
    }
    if (number >= 100) {
        words += numberToBengaliWords(Math.floor(number / 100)) + ' ' + hundred + ' '
        number = number % 100
    }
    words += ones[number]
    return words.trim()
}

function numberToEnglishWords (number) {
    const ones = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
        'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
        'Seventeen', 'Eighteen', 'Nineteen'
    ]
    const tens = [
        '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
    ]
    const hundred = 'Hundred'
    const thousand = 'Thousand'
    const million = 'Million'
    const billion = 'Billion'
    let words = ''
    if (number >= 1000000000) { // Billion
        words += numberToEnglishWords(Math.floor(number / 1000000000)) + ' ' + billion + ' '
        number = number % 1000000000
    }
    if (number >= 1000000) { // Million
        words += numberToEnglishWords(Math.floor(number / 1000000)) + ' ' + million + ' '
        number = number % 1000000
    }
    if (number >= 1000) { // Thousand
        words += numberToEnglishWords(Math.floor(number / 1000)) + ' ' + thousand + ' '
        number = number % 1000
    }
    if (number >= 100) { // Hundred
        words += numberToEnglishWords(Math.floor(number / 100)) + ' ' + hundred + ' '
        number = number % 100
    }
    if (number >= 20) { // Tens
        words += tens[Math.floor(number / 10)] + ' '
        number = number % 10
    }
    words += ones[number] // Ones
    return words.trim()
}

function dateFromNow (value, unitOfTime = Store.getters.commonObj.unitOfTime) {
    require('moment/min/locales.min')
    moment.locale(i18n.locale)
    return moment(value).startOf(unitOfTime).fromNow()
}

function dateFormatTime (value) {
    require('moment/min/locales.min')
    moment.locale(i18n.locale)
    const commonObj = Store.getters.commonObj
    return moment(value).format(commonObj.dateFormat + ' h:mm:ss a')
}

function numberFormatBn (value, $this, config = { }) {
    try {
        if (typeof value !== 'undefined' && value) {
            const firstChar = value.substring(0, 1)
            const hasZero = parseInt(firstChar) === 0
            return hasZero ? (i18n.locale === 'bn' ? '০' + $this.$n(value, config) : '0' + $this.$n(value, config))
                : $this.$n(value, config)
        }
    } catch (e) {
        return value
    }
}

function mobileNumber (value) {
    try {
        if (typeof value !== 'undefined' && value) {
           if (i18n.locale === 'bn') {
               return '০' + i18n.n(value, { useGrouping: false })
           } else {
            return '0' + i18n.n(value, { useGrouping: false })
        }
        }
    } catch (e) {
        return value
    }
}

function capitalize (string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
}
// capitalize all words of a string.
function capitalizeAllWords (string) {
    return string.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase() })
}

function kebabToWords (string) {
    const words = string.split('-')
    const capitalized = words.map(word => capitalize(word))
    return capitalized.join(' ')
}

function snakeToWords (string) {
    const words = string.split('_')
    const capitalized = words.map(word => capitalize(word))
    return capitalized.join(' ')
}
function wordsToSnake (str) {
    if (typeof str !== 'undefined' && typeof str === 'string') {
        const words = str.split(' ')
        return words.join('_').toLowerCase()
    }
}

function getExtension (file) {
    const fileName = file.name
    return fileName.slice((fileName.lastIndexOf('.') - 1 >>> 0) + 2)
}
function randomNumber () {
    return Math.floor(Math.random() * 10000000)
}

function currency ($event, model) {
    const keyCode = ($event.keyCode ? $event.keyCode : $event.which)
    // only allow number and one dot
    if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || model.indexOf('.') !== -1)) { // 46 is dot
        $event.preventDefault()
    }
    // restrict to 2 decimal places
    if (model != null && model.indexOf('.') > -1 && (model.split('.')[1].length > 1)) {
        $event.preventDefault()
    }
}
function truncate (text, length, clamp) {
    clamp = clamp || '...'
    var node = document.createElement('div')
    node.innerHTML = text
    var content = node.textContent
    return content.length > length ? content.slice(0, length) + clamp : content
}
// Vue.filter ('myDate', function (text) {
//   return moment(text).format('MMMM Do YYYY')
// })

Vue.filter('reverse', function (value) {
    // slice to make a copy of array, then reverse the copy
    return value.slice().reverse()
})

Vue.filter('formatDate', function (value) {
    if (value) {
        return moment(String(value)).fromNow()
    }
})

Vue.filter('dateFromNow', function (value) {
    if (value) {
        return dateFromNow(String(value))
    }
})

Vue.filter('formatDateDMY', function (value) {
    if (value) {
        return moment(value).format('DD-MM-YYYY')
    }
})

Vue.filter('timeFormat', function (value) {
    if (value) {
        return moment.parseZone(value).utcOffset()
    }
})

Vue.filter('numberToBengaliWords', function (value) {
    return numberToBengaliWords(value)
})

Vue.filter('numberToEnglishWords', function (value) {
    return numberToEnglishWords(value)
})

Vue.filter('dateFormat', function (value) {
  return dateFormat(value)
})

Vue.filter('newDateFormat', function (value) {
  return newDateFormat(value)
})

Vue.filter('dateFormatTime', function (value) {
    require('moment/min/locales.min')
    moment.locale(i18n.locale)
    const commonObj = Store.getters.commonObj
    return moment(value).format(commonObj.dateFormat + ' h:mm:ss a')
})

Vue.filter('kebabToWords', (value) => {
    if (typeof value !== 'undefined') {
        return kebabToWords(value)
    }
})

Vue.filter('snakeToWords', (value) => {
    if (typeof value !== 'undefined') {
        return snakeToWords(value)
    }
})

Vue.filter('wordsToSnake', (value) => {
    if (typeof value !== 'undefined') {
        return wordsToSnake(value)
    }
})

Vue.filter('numberFormatBn', (value, config = { }) => {
    return numberFormatBn(value, config)
})

Vue.filter('mobileNumber', (value) => {
    return mobileNumber(value)
})

Vue.filter('truncate', (text, length, clamp) => {
   return truncate(text, length, clamp)
})

Vue.filter('capitalizeAllWords', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase() })
})

export { capitalize, capitalizeAllWords, formatNumber, numberToBengaliWords, numberToEnglishWords, dateFormat, newDateFormat, dateFormatTime, numberFormatBn, mobileNumber, kebabToWords, snakeToWords, wordsToSnake, getExtension, randomNumber, currency, dateFromNow, truncate }
